export class CreateData {
  static payloadLogin(username, password) {
    return {
      username,
      password,
    };
  }
}
